var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleMapsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3ddab4",
    d: "M17.425,34.114c1.296,1.621,2.616,3.658,3.306,4.889c0.841,1.6,1.19,2.681,1.816,4.616 C22.913,44.679,23.261,45,23.993,45c0.8,0,1.166-0.54,1.446-1.381c0.585-1.816,1.036-3.197,1.751-4.513 c2.756-5.197,7.248-8.89,9.779-13.95c0,0,1.665-3.091,1.665-7.419c0-4.035-1.641-6.838-1.641-6.838l-19.557,23.25L17.425,34.114z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M10.792,24.609c1.576,3.59,4.582,6.736,6.633,9.505l10.873-12.89c0,0-1.535,2.01-4.308,2.01 c-3.091,0-5.607-2.462-5.607-5.573c0-2.14,1.275-3.624,1.275-3.624c-8.001,1.19-7.556,3.128-8.89,10.565L10.792,24.609z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M28.435,3.674c3.624,1.166,6.701,3.624,8.548,7.214l-8.684,10.36c0,0,1.275-1.491,1.275-3.624 c0-3.176-2.681-5.573-5.573-5.573c-2.746,0-4.308,1.986-4.308,1.986c0.667-1.518,7.556-9.847,8.753-10.36L28.435,3.674z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2100c4",
    d: "M12.775,8.231C14.936,5.66,18.724,3,23.956,3C26.482,3,28.4,3.67,28.4,3.67l-8.719,10.36 c-0.588-0.319-6.325-4.787-6.907-5.812V8.231z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f55376",
    d: "M10.792,24.609c0,0-1.426-2.831-1.426-6.907c0-3.864,1.511-7.248,3.419-9.437l6.907,5.812 l-8.89,10.531H10.792z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsIcon);
export default __webpack_public_path__ + "static/media/googleMapsIcon.94da225c97117c02cb7698c7a9a56a8b.svg";
export { ForwardRef as ReactComponent };